import { render, staticRenderFns } from "./CompanyGeography.vue?vue&type=template&id=1b29c5da&scoped=true&"
import script from "./CompanyGeography.vue?vue&type=script&lang=js&"
export * from "./CompanyGeography.vue?vue&type=script&lang=js&"
import style0 from "./CompanyGeography.vue?vue&type=style&index=0&id=1b29c5da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b29c5da",
  null
  
)

export default component.exports